<div class="theme-toggle-wrapper">
  <button
    class="icon-btn light-icon"
    [class.active]="!isDark()"
    (click)="setTheme('light')"
    [attr.aria-label]="'onboarding.themeToggle.light' | translate"
  >
    <mat-icon>light_mode</mat-icon>
  </button>

  <div
    class="custom-switch"
    (click)="toggle()"
    [class.checked]="isDark()"
    role="switch"
    [attr.aria-checked]="isDark()"
    tabindex="0"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle()"
  >
    <div class="switch-track"></div>
    <div class="switch-thumb"></div>
  </div>

  <button
    class="icon-btn dark-icon"
    [class.active]="isDark()"
    (click)="setTheme('dark')"
    [attr.aria-label]="'onboarding.themeToggle.dark' | translate"
  >
    <mat-icon>dark_mode</mat-icon>
  </button>
</div>
